import React from 'react';
import { productImage, purchaseAnchor } from './constants';
interface ProductImageProps {
  className?: string;
}
export function ProductImage({
  className = 'max-w-[280px]'
}: ProductImageProps) {
  return <a href={purchaseAnchor} className="block" data-id="element-114" data-mp="2ll7w1qu0alpw">
      <img src={productImage} alt="Gym Rythmique Pro — Le Système Complet de Planification 6-en-1 pour les Professeurs de Gymnastique Rythmique" className={`w-full h-auto object-contain mx-auto drop-shadow-xl ${className}`} data-id="element-115" data-mp="2ljwsns4h3fzb" />
    </a>;
}